import { render } from "./record-detail.vue?vue&type=template&id=e5661fa8&scoped=true&ts=true"
import script from "./record-detail.vue?vue&type=script&lang=ts"
export * from "./record-detail.vue?vue&type=script&lang=ts"

import "./record-detail.vue?vue&type=style&index=0&id=e5661fa8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5661fa8"]])

export default __exports__